import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PhoneIncoming, PhoneOff, Video } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { api } from "@/lib/api";

const POLL_MS = 5000;

export function IncomingCall() {
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const [calls, setCalls] = useState([]);

  useEffect(() => {
    if (!user) { setCalls([]); return undefined; }
    let alive = true;
    const tick = () => api.get("/calls/incoming").then((r) => alive && setCalls(r.data)).catch(() => {});
    tick();
    const id = setInterval(tick, POLL_MS);
    return () => { alive = false; clearInterval(id); };
  }, [user]);

  const answer = async (c, action) => {
    setCalls((prev) => prev.filter((x) => x.id !== c.id));
    try {
      await api.post(`/calls/${c.id}/${action}`);
      if (action === "accept") navigate(`/room/${c.meeting_id}`);
    } catch { /* already ended */ }
  };

  if (!user || calls.length === 0 || location.pathname.startsWith("/join/")) return null;
  return (
    <div className="fixed inset-x-4 bottom-4 z-[90] flex flex-col items-end gap-3 sm:inset-x-auto sm:right-6 sm:bottom-6" data-testid="incoming-calls">
      {calls.map((c) => (
        <div key={c.id} className="panel reveal w-full max-w-sm border-vox-bright/40 p-5 shadow-2xl" data-testid={`incoming-call-${c.id}`}>
          <div className="mb-1 flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-vox-bright"><PhoneIncoming size={14} className="animate-breathe" />{t("contacts.incoming")}</div>
          <div className="text-lg font-semibold text-vox-text" data-testid="incoming-call-from">{c.from_name}</div>
          <div className="mt-4 flex gap-2">
            <button type="button" onClick={() => answer(c, "accept")} className="btn-primary flex-1" data-testid="incoming-call-accept"><Video size={14} /> {t("contacts.accept")}</button>
            <button type="button" onClick={() => answer(c, "decline")} className="btn-ghost flex-1 !border-vox-rec/40 !text-[#ff9b9e]" data-testid="incoming-call-decline"><PhoneOff size={14} /> {t("contacts.decline")}</button>
          </div>
        </div>
      ))}
    </div>
  );
}
